module.exports = "<div *ngFor=\"let alert of alerts\" class=\"{{ cssClass(alert) }} alert-dismissable\">\r\n     {{ alert.message | translate }}\r\n</div>\r\n"